<div class="astral-stack-l">
  @if (allowLinkBuildingDocument) {
    <div class="astral-action-with-help">
      <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_WITH_DLG_BTN" (click)="linkDocument()"></astral-button>
    </div>
  }
  <app-list-view
    [columnDefinition]="documentsColumnDefinition"
    [itemsSource]="building.documents"
    [contextMenuDefinition]="documentsContextMenuDefinitions"
    [preferencesKey]="'rent.building-documents.documents'"
  ></app-list-view>
</div>
